const BundleEngine = {

    //
    // Configuration
    //

    config: {},

    elements: {},

    state: {

        products: [],

        bundleItems: [

            {
                product: null,
                options: {},
                variant: null
            },

            {
                product: null,
                options: {},
                variant: null
            }

        ]

    },

    //
    // Initialization
    //

    async init() {

        console.log('Bundle Engine Initializing...');

        this.cacheConfig();

        this.cacheElements();

        await this.loadProducts();

        this.initializeSelections();

        this.render();

        this.bindEvents();

        console.log(this.state);

    },

    getBundleItem(index) {

        return this.state.bundleItems[index];

    },

    cacheConfig() {

        this.config = window.ProductBundle || {};

        console.log('Bundle Type:', this.config.type);

        console.log('Allowed Colors:', this.config.allowedColorValues);

    },

    cacheElements() {

        this.elements = {

            item1: {

                product:
                    document.getElementById(
                        'bundle-item-1-product'
                    ),

                options:
                    document.getElementById(
                        'bundle-item-1-options'
                    ),

                selection:
                    document.getElementById(
                        'bundle-item-1-selection'
                    ),

            },

            item2: {

                product:
                    document.getElementById(
                        'bundle-item-2-product'
                    ),

                options:
                    document.getElementById(
                        'bundle-item-2-options'
                    ),
                
                selection:
                    document.getElementById(
                        'bundle-item-2-selection'
                    ),

            },

            gallery: {

                main:
                    document.getElementById(
                        'bundle-main-image'
                    ),

                thumbs:
                    document.querySelector(
                        '.bundle-gallery__thumbs'
                    )

            },

            quantity:
                document.getElementById(
                    'bundle-quantity'
                ),
            quantityMinus:
                document.querySelector(
                    '.bundle-quantity-minus'
                ),

            quantityPlus:
                document.querySelector(
                    '.bundle-quantity-plus'
                ),

            addToCart:
                document.getElementById(
                    'add-bundle-to-cart'
                )

        };

    },

    //
    // Data Loading
    //

    async loadProducts() {

        if (!this.config.sourceProducts?.length) {

            console.warn('No bundle source products configured.');

            return;

        }

        this.state.products = [];

        for (const configProduct of this.config.sourceProducts) {

            console.log(`Loading ${configProduct.handle}...`);

            const response = await fetch(
                `/products/${configProduct.handle}.js`
            );

            const shopifyProduct =
                await response.json();
            
            console.log(shopifyProduct);

            const product = {

                ...shopifyProduct,

                bundle: {

                    featuredImage:
                        configProduct.featuredImage,

                    swatchColor:
                        configProduct.swatchColor,
                    
                    colorName:
                        configProduct.colorName

                }

            };

            this.state.products.push(product);

        }

    },

    initializeSelections() {
        
        if (!this.state.products.length) {

            console.warn('No available products to initialize.');

            return;

        }

        const firstProduct =
            this.state.products[0];

        this.state.bundleItems.forEach(item => {

            item.product = firstProduct;

            item.options = {};

            let firstAvailableVariant;

            //
            // Single-product bundles:
            // Start with the first available variant
            // whose Color is in the allowed list.
            //

            if (
                this.config.type === 'single' &&
                this.config.allowedColorValues?.length
            ) {

                firstAvailableVariant =
                    firstProduct.variants.find(variant => {

                        return (
                            variant.available &&
                            this.config.allowedColorValues.includes(variant.option1)
                        );

                    });

            }

            //
            // Multi-product bundles (or fallback)
            //

            firstAvailableVariant =
                firstAvailableVariant ||
                firstProduct.variants.find(variant => variant.available) ||
                firstProduct.variants[0];

            firstProduct.options.forEach((option, index) => {

                item.options[option.name] =
                    firstAvailableVariant[`option${index + 1}`];

            });

            item.variant =
                firstAvailableVariant;

        });

        //
        // Normalize each bundle item to the
        // first available in-stock variant.
        //

        this.state.bundleItems.forEach((item, index) => {

            this.findMatchingVariant(index);

            this.ensureValidSelection(index);

        });

    },

    //
    // Rendering
    //

    render() {

        this.renderBundleItems();

        this.initializeStaticGallery();

    },

    renderBundleItems() {

        this.state.bundleItems.forEach((item, index) => {

            this.renderBundleItem(index);

        });

    },

    renderBundleItem(index) {

        if (this.config.type === 'multi') {

            this.renderProductSelector(index);

        }

        this.renderOptionSelectors(index);

    },

    

    initializeStaticGallery() {


        const mainImage =
            document.getElementById('bundle-main-image');

        const thumbnails =
            document.querySelectorAll('.bundle-gallery__thumb');

        thumbnails.forEach(button => {

            button.addEventListener('click', () => {

                mainImage.src =
                    button.dataset.image;

                thumbnails.forEach(thumb => {

                    thumb.classList.remove('is-active');

                });

                button.classList.add('is-active');

            });

        });

    },

    renderProductSelector(index) {

        const container =
            this.elements[`item${index + 1}`].product;

        if (!container) {

            return;

        }

        container.innerHTML = '';

        this.state.products.forEach(product => {

            const button = document.createElement('button');

            button.type = 'button';

            button.className =
                'bundle-product-button';

            const bundleItem =
                this.getBundleItem(index);

            if (bundleItem.product.id === product.id) {

                button.classList.add('is-active');

            }

            button.dataset.item = index;

            button.dataset.product = product.id;

            button.innerHTML = `
                <span
                    class="bundle-color-swatch"
                    style="background-color: ${product.bundle.swatchColor};">
                </span>
            `;

            container.appendChild(button);

        });

        // NEW CODE HERE
        const bundleItem =
            this.getBundleItem(index);

        if (this.config.type === 'multi') {
            this.elements[`item${index + 1}`].selection.innerHTML = `
                <span class="bundle-step__selection-label">
                    Selected:
                </span>
                <span class="bundle-step__selection-value">
                    ${bundleItem.product.bundle.colorName}
                </span>
            `;
        }

    },

    renderOptionSelectors(index) {

        const container =
            this.elements[`item${index + 1}`].options;

        if (!container) {

            return;

        }

        container.innerHTML = '';

        const bundleItem =
            this.getBundleItem(index);

        bundleItem.product.options.forEach((option, optionIndex) => {

            const group =
                document.createElement('div');

            group.className =
                'bundle-option-group';

            const label =
                document.createElement('h4');

            label.innerHTML = `
                ${option.name}: <span class="bundle-option-value">
                    ${bundleItem.options[option.name]}
                </span>
            `;

            group.appendChild(label);
            
            let values = option.values;

            if (
                this.config.type === 'single' &&
                option.name === 'Color' &&
                this.config.allowedColorValues?.length
            ) {

                values = values.filter(value =>
                    this.config.allowedColorValues.includes(value)
                );

            }

            values.forEach(value => {

                const available =
                    this.isOptionValueAvailable(
                        bundleItem,
                        optionIndex,
                        value
                    );

                if (!available) {

                    return;

                }

                const button = document.createElement('button');

                button.type =
                    'button';

                button.className =
                    'bundle-option-button';

                button.dataset.item =
                    index;

                button.dataset.option =
                    option.name;

                button.dataset.value =
                    value;

                if (
                    this.config.type === 'single' &&
                    option.name === 'Color'
                ) {

                    button.innerHTML = `
                        <shape-swatch
                            data-color="${value}"
                            data-colors-patterns="${this.config.swatchPatterns || ''}"
                            class="color-swatch color-swatch--round">

                            <div class="color-swatch__line"></div>

                        </shape-swatch>
                    `;

                } else {

                    button.textContent = value;

                }
                
                if (bundleItem.options[option.name] === value) {

                    button.classList.add('is-active');

                }
                
                group.appendChild(button);

                });

            container.appendChild(group);

        });

    },

    renderPillOption(group, option, optionIndex, bundleItem, index, values) {

        values.forEach(value => {

            const button = document.createElement('button');

            button.type = 'button';

            button.className = 'bundle-option-button';

            button.dataset.item = index;

            button.dataset.option = option.name;

            button.dataset.value = value;

            const available =
                this.isOptionValueAvailable(
                    bundleItem,
                    optionIndex,
                    value
                );

            if (!available) {

                button.disabled = true;

                button.classList.add('is-disabled');

            }

            button.textContent = value;

            if (bundleItem.options[option.name] === value) {

                button.classList.add('is-active');

            }

            group.appendChild(button);

        });

    },

    //
    // Event Handling
    //

    bindEvents() {

        document.addEventListener('click', (event) => {

            const productButton =
                event.target.closest('.bundle-product-button');

            if (productButton) {

                this.selectProduct(

                    Number(productButton.dataset.item),

                    Number(productButton.dataset.product)

                );

                return;

            }

            const optionButton =
                event.target.closest('.bundle-option-button');

            if (optionButton) {

                this.selectOption(

                    Number(optionButton.dataset.item),

                    optionButton.dataset.option,

                    optionButton.dataset.value

                );

                return;

            }

            const addToCartButton =
                event.target.closest('#add-bundle-to-cart');

            if (addToCartButton) {

                this.addBundleToCart();

            }

        });

        this.elements.quantityMinus?.addEventListener(
            'click',
            () => {

                const quantity =
                    this.elements.quantity;

                quantity.value =
                    Math.max(
                        1,
                        Number(quantity.value) - 1
                    );

            }
        );

        this.elements.quantityPlus?.addEventListener(
            'click',
            () => {

                const quantity =
                    this.elements.quantity;

                quantity.value =
                    Number(quantity.value) + 1;

            }
        );

    },

    //
    // Cart
    //

    async addBundleToCart() {

        console.log('Add Bundle Clicked');

        const quantity =
    Number(this.elements.quantity.value);

    const items =
        this.state.bundleItems.map(bundleItem => {

            return {

                id: bundleItem.variant.id,

                quantity

            };

    });

        console.log(items);

        const response = await fetch('/cart/add.js', {

            method: 'POST',

            headers: {

                'Content-Type': 'application/json'

            },

            body: JSON.stringify({

                items

            })

        });

        if (!response.ok) {

            console.error('Failed to add bundle.');

            console.log(await response.text());

            return;

        }

        window.location.href = '/cart';

    },

    selectProduct(itemIndex, productId) {

        const product =
            this.state.products.find(product => {

                return product.id === productId;

            });

        if (!product) {

            return;

        }

        const bundleItem =
            this.getBundleItem(itemIndex);

        bundleItem.product =
            product;

        const firstAvailableVariant =
            product.variants.find(variant => variant.available)
            || product.variants[0];

        //
        // Preserve the current selections when
        // changing colors.
        //

        this.findMatchingVariant(itemIndex);

        this.ensureValidSelection(itemIndex);

        //
        // If the selected combination doesn't exist,
        // fall back to the first available variant.
        //

        if (!bundleItem.variant) {

            const firstAvailableVariant =
                product.variants.find(variant => variant.available)
                || product.variants[0];

            bundleItem.options = {};

            product.options.forEach((option, index) => {

                bundleItem.options[option.name] =
                    firstAvailableVariant[`option${index + 1}`];

            });

            bundleItem.variant = firstAvailableVariant;

        }
        
        if (this.config.type === 'multi' && itemIndex === 0) {

            const awayItem = this.getBundleItem(1);

            awayItem.product = product;

            awayItem.options = { ...bundleItem.options };

            this.findMatchingVariant(1);

            this.ensureValidSelection(1);

            this.renderBundleItem(1);

        }
    
        
        this.renderBundleItem(itemIndex);

        console.log(bundleItem);

    },

    selectOption(itemIndex, optionName, value) {

        const bundleItem =
            this.getBundleItem(itemIndex);

        bundleItem.options[optionName] =
            value;

        const changedOptionIndex =
            bundleItem.product.options.findIndex(option => {

                return option.name === optionName;

            });

        this.findMatchingVariant(itemIndex);

        this.ensureValidSelection(
            itemIndex,
            changedOptionIndex
        );

        if (this.config.type === 'multi' && itemIndex === 0) {

            const awayItem = this.getBundleItem(1);

            awayItem.options = { ...bundleItem.options };

            this.findMatchingVariant(1);

            this.ensureValidSelection(1, changedOptionIndex);

            this.renderBundleItem(1);

        }

        this.renderBundleItem(itemIndex);

    },

    //
    // Variant Selection
    //

    findMatchingVariant(itemIndex) {

        const bundleItem =
            this.getBundleItem(itemIndex);

        const variant =
            bundleItem.product.variants.find(variant => {

                if (!variant.available) {

                    return false;

                }

                return bundleItem.product.options.every((option, index) => {

                    return variant[`option${index + 1}`] ===
                        bundleItem.options[option.name];

                });

            });

        if (!variant) {

            bundleItem.variant = null;

            return;

        }

        bundleItem.variant =
            variant;

    },

    ensureValidSelection(itemIndex, changedOptionIndex) {

        const bundleItem =
            this.getBundleItem(itemIndex);

        //
        // Current selections already produce
        // a valid variant.
        //

        if (bundleItem.variant) {

            return;

        }

        //
        // Find the first available variant that
        // matches every option the user has
        // already chosen.
        //

        const variant =
            bundleItem.product.variants.find(variant => {

                console.log('replacement variant:', variant);

                if (!variant.available) {

                    return false;

                }

                //
                // Preserve every option up to
                // and including the option the
                // user just changed.
                //

                for (
                    let i = 0;
                    i <= changedOptionIndex;
                    i++
                ) {

                    const option =
                        bundleItem.product.options[i];

                    if (
                        variant[`option${i + 1}`] !==
                        bundleItem.options[option.name]
                    ) {

                        return false;

                    }

                }

                return true;

            });

        if (!variant) {

            return;

        }

        //
        // Copy every option value from the
        // replacement variant.
        //

        bundleItem.product.options.forEach((option, index) => {

            bundleItem.options[option.name] =
                variant[`option${index + 1}`];

        });

        bundleItem.variant =
            variant;

    },

    isOptionValueAvailable(bundleItem, optionIndex, value) {

        //
        // First option is always available.
        //

        if (optionIndex === 0) {

            return true;

        }

        return bundleItem.product.variants.some(variant => {

            if (!variant.available) {

                return false;

            }

            //
            // Previous options must match the current selections.
            //

            for (let i = 0; i < optionIndex; i++) {

                const option =
                    bundleItem.product.options[i];

                if (
                    variant[`option${i + 1}`] !==
                    bundleItem.options[option.name]
                ) {

                    return false;

                }

            }

            //
            // This option must match the value we're evaluating.
            //

            return (
                variant[`option${optionIndex + 1}`] ===
                value
            );

        });

    },

};

document.addEventListener('DOMContentLoaded', () => {

    BundleEngine.init();

});